module.exports = __webpack_public_path__ + "img/secure-images.5f687527.webp";